<p>
  By default this is the highest average of your base annual earnings plus
  pensionable AIP up to your target over 36 or 60 consecutive months, as
  applicable, as of your last annual pension statement.
</p>
<p>
  If you had a recent salary increase and would like this increase reflected in
  the pension projections shown, you can override your last annual pension
  statement average.
</p>
